import { MaintenanceStatus } from "../maintenance.enums";
import type { MaintenanceHistoryEntry } from "../types/maintenance.types";

import { BadgeVariants } from "@/components/ui/Badge";
import { formatToCapitalizedWords } from "@/utils/core/generalUtils";

export const maintenanceApiRoutes = {
  getCurrentMaintenanceWindow: "/maintenance-window/current",
  createMaintenanceWindow: "/maintenance-window/admin",
  getMaintenanceWindows: "/maintenance-window/admin",
  updateMaintenanceWindow: "/maintenance-window/admin/:id",
  cancelMaintenanceWindow: "/maintenance-window/admin/:id/cancel",
};

export const MAINTENANCE_FILTER_KEYS = ["date", "status"];

export const MAINTENANCE_STATUS_VARIANT: Record<
  MaintenanceHistoryEntry["status"],
  BadgeVariants
> = {
  ACTIVE: "lightSuccessWithBorder",
  SCHEDULED: "yellowWithBorder",
  CANCELLED: "lightDestructiveWithBorder",
  RELEASED: "lightWarning",
};

export const MAINTENANCE_STATUS_OPTIONS = Object.values(MaintenanceStatus).map(
  (status) => ({
    label:
      status === MaintenanceStatus.CANCELLED
        ? "Aborted"
        : formatToCapitalizedWords(status),
    id: status,
  }),
);
